export default __webpack_public_path__ + "static/media/giphy-icon.eb0b185d.png";